import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from '../Button';
import getRedirectUrlAfterLogin from 'utils/getRedirectUrlAfterLogin';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    backgroundColor: '#D91A5B',
    color: '#FFFFFF',
  },
  container: {
    maxWidth: '1120px',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    animation: '$fadeIn 0.6s ease-out',
  },
  title: {
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    [theme.breakpoints.up('md')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '3.75rem',
    },
  },
  description: {
    fontSize: '1.125rem',
    opacity: 0.95,
    maxWidth: '672px',
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export default function FinalCTA() {
  const classes = useStyles();

  const handleCreateNowClick = () => {
    window.location.href = getRedirectUrlAfterLogin();
  };

  return (
    <section className={classes.section}>
      <Container className={classes.container}>
        <Box className={classes.content}>
          <Typography className={classes.title} component="h2">
            Bring Your Research to Life with Mind The Graph
          </Typography>
          <Typography className={classes.description}>
            Join 500,000+ researchers already visualizing their science with ease.
          </Typography>
          <Box>
            <Button
              size="large"
              variant="outlined"
              component="a"
              style={{
                backgroundColor: '#FFFFFF',
                color: '#121212',
                borderColor: '#FFFFFF',
                boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
              }}
              onClick={handleCreateNowClick}
            >
              Create Now – It's Free
            </Button>
          </Box>
        </Box>
      </Container>
    </section>
  );
}
